import 'typeface-montserrat';

// Montserrat is kept. What changed is the scale, which had two defects:
//
//   h6 was 24px — larger than h5 (16px) and equal to h3, so heading order did not
//   correspond to size, and
//
//   fontWeight was given as 'medium' and 'bold' on h1/h2. 'medium' is not a valid CSS
//   font-weight keyword, so the browser discarded it and those headings rendered at the
//   default weight.
//
// Sizes are rem so they respond to the user's browser text size. Line heights are set
// explicitly: the previous scale had none, so headings inherited body leading and looked
// cramped. Negative letter-spacing is kept only on the large sizes where it helps.

export default {
  fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    fontSize: '2rem',      // 32px
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontWeight: 700,
    fontSize: '1.625rem',  // 26px
    lineHeight: 1.25,
    letterSpacing: '-0.015em',
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.375rem',  // 22px
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.125rem',  // 18px
    lineHeight: 1.35,
  },
  h5: {
    fontWeight: 600,
    fontSize: '1rem',      // 16px
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 600,
    fontSize: '0.9375rem', // 15px — now the smallest heading, as the level implies
    lineHeight: 1.4,
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: '0.9375rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '0.9375rem', // 15px, up from the MUI default 16 being used unstyled
    lineHeight: 1.6,
  },
  body2: {
    fontSize: '0.875rem',  // 14px
    lineHeight: 1.6,
  },
  button: {
    fontWeight: 600,
    fontSize: '0.875rem',
    letterSpacing: '0.01em',
    textTransform: 'none',  // ALL CAPS buttons are the single strongest dated signal
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
  },
  overline: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
};
